import axios from "axios";
import type { GetCustomerClientKeyFobStats } from "../shared/interface/customerClient.interface";

export const getCustomerClientKeyFobStats = async (customerClientId: number) => {
  const query = `${process.env.REACT_APP_API_URL}/customer-client/key-fob-allocation/stats?customerClientId=${customerClientId}`;

  try {
    const response = await axios.get(query);

    return response.data as GetCustomerClientKeyFobStats;
  } catch (error) {
    throw error;
  }
};
